import { useState } from "react";
import FadeInView from "./FadeInView";
import Typewriter from "./Typewriter";

/* ── ICONS ── */
const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
    <path d="M7 17 17 7M7 7h10v10" />
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// ── CONFIGURE YOUR EMAILJS CREDENTIALS HERE ──
const EMAILJS_SERVICE_ID = "service_50dvft5";
const EMAILJS_TEMPLATE_ID = "template_v1ylskp";
const EMAILJS_PUBLIC_KEY = "gbiJWOPT8mAsiS4VL";
// ─────────────────────────────────────────────
// Get your credentials at https://www.emailjs.com/
// 1. Create an account
// 2. Add an Email Service → copy Service ID
// 3. Create an Email Template → copy Template ID
// 4. Go to Account → API Keys → copy Public Key

export default function Contact() {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({ user_name: "", user_email: "", message: "" });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setError("");

    // Check if emailjs is configured
    if (EMAILJS_SERVICE_ID === "service_id") {
      setError("Email service not configured. Set your EmailJS credentials in Contact.js");
      return;
    }

    setSending(true);

    try {
      const emailjs = await import("emailjs-com");
      const templateParams = {
        user_name: formData.user_name,
        user_email: formData.user_email,
        message: formData.message,
        reply_to: formData.user_email,
        from_name: formData.user_name,
        title: formData.user_name,
        to_name: "Saket",
      };

      await emailjs.default.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
      setSending(false);
      setSent(true);
    } catch (err) {
      setSending(false);
      console.error("Email send error:", err);
      if (err.text) {
        setError(err.text);
      } else if (err.message) {
        setError(err.message);
      } else {
        setError("Failed to send message. Please check your EmailJS configuration.");
      }
    }
  };

  if (sent) {
    return (
      <div>
        <FadeInView>
          <p className="section-number"><Typewriter text="[03] ./contact --inbox" /></p>
          <h2 className="section-title">Contact</h2>
        </FadeInView>

        <FadeInView delay={0.1}>
          <div className="contact-sent">
            <div className="contact-sent-icon"><IconCheck /></div>
            <h3 className="display-medium" style={{ marginBottom: "0.4em" }}>[ message_sent ]</h3>
            <p className="body-text" style={{ textAlign: "center" }}>
              {">_ "}Thank you! I'll get back to you as soon as possible.
            </p>
            <button
              className="form-submit"
              onClick={() => { setSent(false); setError(""); setFormData({ user_name: "", user_email: "", message: "" }); }}
              style={{ marginTop: "2em" }}
            >
              [ ./send_another → ]
            </button>
          </div>
        </FadeInView>
      </div>
    );
  }

  return (
    <div>
      <FadeInView>
        <p className="section-number">[03] ./contact --inbox</p>
        <h2 className="section-title">Contact</h2>
      </FadeInView>

      <FadeInView delay={0.1}>
        <p className="contact-text">
          {">_ "}Have an opportunity or just want to say hi? My inbox is always open.
          Whether you have a project in mind, a collaboration proposal, or just want to connect — I'd love to hear from you.
        </p>
      </FadeInView>

      <div className="contact-layout">
        <FadeInView delay={0.15}>
          <div className="contact-links">
            {[
              { label: "Email", val: "saketkhundia21@gmail.com", href: "mailto:saketkhundia21@gmail.com" },
              { label: "GitHub", val: "github.com/saketkhundia", href: "https://github.com/saketkhundia" },
              { label: "LinkedIn", val: "linkedin.com/in/saketkhundia", href: "https://www.linkedin.com/in/saketkhundia" },
            ].map(({ label, val, href }) => (
              <a key={label} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="contact-link">
                <div>
                  <span className="contact-link-label">{label}</span>
                  <span className="contact-link-value">{val}</span>
                </div>
                <span style={{ marginLeft: "auto", color: "var(--muted)" }}>
                  <IconArrow />
                </span>
              </a>
            ))}
          </div>
        </FadeInView>

        <FadeInView delay={0.2}>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="name">~/name</label>
              <input type="text" id="name" name="user_name" placeholder="> enter_your_name_" required value={formData.user_name} onChange={handleChange} />
            </div>
            <div className="form-field">
              <label htmlFor="email">~/email</label>
              <input type="email" id="email" name="user_email" placeholder="> you@email.com_" required value={formData.user_email} onChange={handleChange} />
            </div>
            <div className="form-field">
              <label htmlFor="message">~/message</label>
              <textarea id="message" name="message" rows="5" placeholder="> tell_me_what's_on_your_mind…_" required value={formData.message} onChange={handleChange} />
            </div>

            {error && <div className="form-error">{error}</div>}

            <button type="submit" className="form-submit" disabled={sending}>
              {sending ? "[ sending… ]" : "[ ./send_message ]"} <IconArrow />
            </button>
          </form>
        </FadeInView>
      </div>
    </div>
  );
}
